import React, { useState, useCallback } from "react";
import { Button, Modal, Col, Row, Spinner, Card } from "react-bootstrap";
import ApiUserManager from "../../../core/api/api.userManager";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiAmusementPackage from "../../../core/api/api.amusementPackage";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";


export const PackageOrderModal = ({ packageOrderModal, setPackageOrderModal, packages }) => {

  const [listData, setListData] = useState(packages?.data || [])

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();

  const handleClose = () => setPackageOrderModal(false);

  const onSubmit = async (data) => {
    try {
      return

      let response = await ApiAmusementPackage.createEditAmusementPackage(data);

      if (response.succeeded == true) {
        document.getElementById("submitButton").click();
        handleClose();
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  const handleDragEnd = useCallback(
    (result) => {
      if (!result.destination) return;
      const updatedListData = Array.from(listData);
      const [reorderedItem] = updatedListData.splice(result.source.index, 1);
      updatedListData.splice(result.destination.index, 0, reorderedItem);
      setListData(updatedListData);
    },
    [listData],
  );

  return (
    <div>
      <Modal centered size="md" show={packageOrderModal} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title> تغییر ترتیب پکیج های تفریحات</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <ul className="sortable-list" {...provided.droppableProps} ref={provided.innerRef}>
                    {listData.map((item, index) => (
                      <Draggable key={index} draggableId={index.toString()} index={index}>
                        {(provided) => (
                          <li
                            className="sortable-item d-flex justify-content-center mb-5"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <p>{item.title}</p>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
